import axios from 'axios';
import { mutate } from 'swr';

import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';

const path = `${SERVICES.USER}/teams/copy`;

interface IRequestCopyTeam {
  oldPeriodId: string;
  newPeriodId: string;
}

export const requestCopyTeam = (data: IRequestCopyTeam) => {
  return mutate(path, async() => {
    try {
      await axios.post(path, data);
      Notistack.successMessage('Team - Copied Successfully');
    } catch (error) {
      Notistack.generalError(getError(error));
    }
  });
};
